import { useStepper } from 'LearningManager/hooks/Stepper.context';
import useTenantScope from 'LearningManager/hooks/useTenantScope';

/**
 * Super admins pick it with the sidebar's global tenant selector, so their
 * course catalog, learning paths and audience lists all have to be asked for by
 * tenant. Everyone else is already scoped to their own tenant by their token,
 * so no tenant is sent and the APIs answer with what that user can see — which
 * is why this returns `undefined` rather than falling back to some other id.
 *
 * Editing is the exception: the assignment carries its own tenant id, so irrespctive
 * of the logged in user, An assignment can be editted.
 */
export const useAssignmentTenantId = (): number | undefined => {
	const { assignmentTenantId } = useStepper();
	const { globalTenantId } = useTenantScope();

	return assignmentTenantId ?? globalTenantId;
};

export default useAssignmentTenantId;
